import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

import { ExternalLinkIcon } from '@/imports/ui/chakra/feather';

export const ExternalRegistrationModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  externalRegistrationUrl: string;
  /** Courses / Intuto collections: enrollment-oriented copy */
  useLearningRegistrationCopy?: boolean;
}> = ({
  isOpen,
  onClose,
  externalRegistrationUrl,
  useLearningRegistrationCopy,
}) => {
  const learning = !!useLearningRegistrationCopy;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {learning ? 'Enrollment Details' : 'Registration Details'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            {learning
              ? 'Enrollment for this course is hosted on an external platform. You may experience a delay before your enrollment status is reflected within Tradewing.'
              : 'Registration for this event is hosted on an external platform. You may experience a delay before your registration status is reflected within Tradewing.'}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" colorScheme="gray" onClick={onClose} mr="2">
            Close
          </Button>

          <Button
            as="a"
            target="_blank"
            rel="noreferrer"
            href={externalRegistrationUrl}
            rightIcon={<ExternalLinkIcon />}
          >
            {learning
              ? 'Enroll on External Platform'
              : 'Register on External Platform'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
